import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/background-item1.png'
import _imports_2 from '@/assets/preview/dashboard.png'
import _imports_3 from '@/assets/widget.png'
import _imports_4 from '@/assets/menu.png'


const _withScopeId = n => (_pushScopeId("data-v-1c111bd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "contents" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image-shadow",
  src: _imports_0,
  alt: "ロゴ"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "side-images" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "mouse-transition-image",
    src: _imports_1,
    alt: "背景画像",
    loading: "lazy"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image1 reveal" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "ダッシュポード",
    loading: "lazy"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feature-number" }, "First", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image2 reveal" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "image-shadow",
    src: _imports_3,
    alt: "ウィジェット",
    loading: "lazy"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feature-number" }, "Second", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image3 reveal" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "image-shadow",
    src: _imports_4,
    alt: "メニュー",
    loading: "lazy"
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feature-number" }, "Third", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "ロゴ",
  class: "icon",
  loading: "lazy"
}, null, -1))

import { onMounted } from "vue";
import InstallButton from "@/components/InstallButton.vue";
import ApplicationMessage from "@/components/ApplicationMessage.vue";
import ScrollReveal from "scrollreveal";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const appName = "TypeRunner";
const appShortDescription = "タイピング回数記録アプリ";
const message = `いままでキーボードを叩いた回数\n気にならない？`;
const supportOSVersion = "*macOS 11.2 以降";
const widgetSupportOSVersion = "*macOS 12 以降";
const latestVersion = "1.1.0";

const contentMessage = "タイピングを記録しよう！";
const contentSubMessage =
  "アプリを起動するだけでOK！\n記録したデータは様々な形で確認することが可能です";
const firstContentText = "ダッシュボード";
const firstContentDescription = `タイピングの記録をグラフやリストで可視化。\nアプリケーションごとの入力数も確認できます。`;
const secondContentText = "ウィジェット";
const secondContentDescription = `通知センターから、タイピング数をチェックできます。`;
const thirdContentText = "メニュー";
const thirdContentDescription = `メニューバーからリアルタイムでタイピング数を見ることができます。`;

const mySiteUrl = "https://nhiroyasu.com";

onMounted(() => {
  ScrollReveal().reveal(".reveal", {
    duration: 1500,
    distance: "100px",
    opacity: 0,
    viewFactor: 1.0,
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", { id: "app-message" }, _toDisplayString(message)),
        _createElementVNode("div", { class: "app-name-wrapper" }, [
          _hoisted_4,
          _createElementVNode("div", {
            id: "app-name",
            class: "eng-font"
          }, _toDisplayString(appName)),
          _createElementVNode("div", { class: "app-short-description" }, _toDisplayString(appShortDescription))
        ]),
        _createVNode(InstallButton, { id: "install-button" }),
        _createElementVNode("div", { class: "app-support-os-version" }, _toDisplayString(supportOSVersion))
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", { class: "description-group" }, [
      _createElementVNode("div", { class: "title" }, _toDisplayString(contentMessage)),
      _createElementVNode("div", { class: "sub-title" }, _toDisplayString(contentSubMessage)),
      _createElementVNode("div", { class: "feature" }, [
        _hoisted_6,
        _createElementVNode("div", { class: "text1 reveal" }, [
          _hoisted_7,
          _createElementVNode("div", { class: "feature-text" }, _toDisplayString(firstContentText)),
          _createElementVNode("div", { class: "feature-description" }, _toDisplayString(firstContentDescription))
        ]),
        _hoisted_8,
        _createElementVNode("div", { class: "text2 reveal" }, [
          _hoisted_9,
          _createElementVNode("div", { class: "feature-text" }, _toDisplayString(secondContentText)),
          _createElementVNode("div", { class: "feature-description" }, _toDisplayString(secondContentDescription)),
          _createElementVNode("div", { class: "app-support-os-version" }, _toDisplayString(widgetSupportOSVersion))
        ]),
        _hoisted_10,
        _createElementVNode("div", { class: "text3 reveal" }, [
          _hoisted_11,
          _createElementVNode("div", { class: "feature-text" }, _toDisplayString(thirdContentText)),
          _createElementVNode("div", { class: "feature-description" }, _toDisplayString(thirdContentDescription))
        ])
      ])
    ]),
    _createVNode(ApplicationMessage, { class: "application-message" }),
    _createElementVNode("div", { class: "copy-right-group" }, [
      _createElementVNode("div", { class: "app" }, [
        _hoisted_12,
        _createElementVNode("div", { class: "name eng-font" }, _toDisplayString(appName))
      ]),
      _createElementVNode("div", { class: "copy-right eng-font" }, [
        _createElementVNode("a", {
          href: mySiteUrl,
          target: "_blank",
          rel: "noopener noreferrer"
        }, "© Hiroyasu Niitsuma")
      ])
    ])
  ]))
}
}

})